define(function (require) {
    "use strict";

    var LE = require("app"),
        ChatWindowCoBrowseController = {},

        COBROWSE_EVENTS = {
            OFFERED: "cobrowseOffered",
            ACCEPTED: "cobrowseAccepted",
            DECLINED: "cobrowseDeclined"
        };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ChatWindowCoBrowseController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize : entered", "ChatWindowCoBrowseController.initialize");
                options = options || {};
                this._chatVent = options.chatVent;

                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this._chatVent, "chatConnection:chat:sessionInfo", this._onSessionInfo);

                this.listenTo(this._chatVent, "chatConnection:cobrowse:offered", this._onCoBrowseOffered);
                this.listenTo(this._chatVent, "chatConnection:cobrowse:accepted", this._onCoBrowseAccepted);
                this.listenTo(this._chatVent, "chatConnection:cobrowse:rejected", this._onCoBrowseRejected);

            },

            _onSessionInfo: function(info){
                this._chatSessionInfo = info;
            },

            _onCoBrowseOffered: function (serviceId) {
                this._publishCoBrowseEvent(COBROWSE_EVENTS.OFFERED, serviceId);
            },

            _onCoBrowseAccepted: function (serviceId) {
                this._publishCoBrowseEvent(COBROWSE_EVENTS.ACCEPTED, serviceId);
            },

            _onCoBrowseRejected: function (serviceId) {
                this._publishCoBrowseEvent(COBROWSE_EVENTS.DECLINED, serviceId);
            },

            _publishCoBrowseEvent: function (eventName, serviceId) {
                if (lpTag && lpTag.events && this._chatSessionInfo) {
                    lpTag.events.trigger({
                        appName: "lpUnifiedWindow",
                        eventName: eventName,
                        data: {
                            agentId: this._chatSessionInfo.agentId,
                            serviceId: serviceId,
                            chatId: this._chatSessionInfo.chatId,
                            visitorName: this._chatSessionInfo.visitorName,
                            ssid: "-1",
                            svid: "-1",
                            cid: "-1"
                        },
                        global: true
                    });
                }
            }


        });
    });

    return ChatWindowCoBrowseController;
});